<template>
  <div>
    <h3 class="text-center">
      CONTRATO DE ADHESIÓN A LA PRESTACIÓN DE SERVICIOS
    </h3>
    <div class="d-flex justify-end">Barcelona a {{ date }}</div>
    <h4>EL PRESTADOR</h4>
    <p>CONEPTUM S.L., NIF B-65946956</p>
    <p>calle Sant Agustí número 3-5 Barcelona</p>

    <h4>EL CLIENTE</h4>
    <p>{{ business_name }}, {{ bussnies_id }}</p>
    <p>{{ postal_address }} - {{ province }}</p>

    <h4 class="text-center">Preámbulo</h4>
    <p>
      Que la mercantil Coneptum ha desarrollado una plataforma tecnológica que
      ofrece soluciones a empresas y profesionales. La plataforma se denomina
      INMATIC y es un procesador automático de contabilización de facturas y
      documentos análogos.
    </p>
    <p>
      Este contrato está compuesto por el presente documento y sus anexos, que
      serán considerados parte inseparable del mismo.
    </p>

    <h4 class="text-center">ESTIPULACIONES</h4>

    <ol type="1">
      <li>
        Objeto
        <ol type="a">
          <li>
            El objeto del presente contrato es la regulación de los términos y
            condiciones en los que Coneptum provisionará y prestará sus
            Servicios al Cliente, así como la especificación de sus detalles
            técnicos y características.
          </li>
          <li>
            Todos los Servicios prestados por Coneptum están regulados y se
            regirán por las estipulaciones recogidas en el presente Contrato. No
            obstante, lo anterior, debido a la heterogeneidad o complejidad
            técnica, algunos Servicios pueden estar sujetos a condiciones
            particulares de contratación que serán integradas al presente
            contrato como Anexo.
          </li>
        </ol>
      </li>
      <li>
        Servicio

        <p>Descripción del producto</p>
        <p>
          INMATIC es una solución que permite mediante un escaneo del documento
          y de forma automática la contabilización en el programa contable de
          facturas, tickets de gastos e ingresos y otros documentos análogos.
        </p>
        <p>Especificaciones del programa:</p>
        <p>
          Contabiliza facturas de profesionales, tickets de caja, facturas con
          retenciones, Iva y otros impuestos.
        </p>
        <p>
          Dentro de las funciones estándares se encuentra la extracción de los
          siguientes ítems:
        </p>
        - Proveedor/Cliente<br />
        - Nif proveedor y Nif cliente<br />
        - Número de la factura<br />
        - Fecha de la factura<br />
        - Fecha de vencimiento de la factura<br />
        - Base imponible<br />
        - IVA/IGIC<br />
        - Total de la factura<br />
        - Retención de IRPF<br />
        <br />

        <p>
          La contratación del servicio de INMATIC, conlleva la integración de
          esta funcionalidad al programa que indique el cliente, siempre que no
          haya alguna incompatibilidad
        </p>
      </li>

      <li>
        Duración de los Servicios
        <p>
          La duración del Contrato de Servicio será de doce (12) meses a contar
          desde su entrada en vigor y será renovado de forma automática por
          periodos de igual tiempo, salvo que cualquiera de las Partes notifique
          a la otra Parte su deseo de no renovarlo con una antelación mínima, de
          30 días naturales. Se acuerda que la notificación a través de correo
          electrónico para prorrogar o resolver el contrato será aceptada como
          medio de comunicación válido entre las partes.
        </p>
        <p>
          El servicio se considera un servicio (Saas) “software as a service”,
          con lo que se entenderá que, si el servicio no se paga, se deja de
          obtener el servicio, siempre que el Cliente no atienda al
          requerimiento de pago del proveedor.
        </p>
        <p>
          Una vez el Cliente acepta y firma el contrato, le llega un correo
          electrónico el cual irá con las indicaciones de como acceder a la
          plataforma y poder operar con los servicios contratados.
        </p>
      </li>

      <li>
        Pago de los Servicios
        <ol type="a">
          <li>
            La Cuota del servicio, es decir el pago recurrente que el Cliente
            debe realizar de forma periódica por la prestación del Servicio, se
            facturará de forma anticipada el día 1 de cada período. El pago se
            realizará de la forma indicada en el anexo adjunto al presente
            contrato.
          </li>
          <li>
            El período de facturación será indicado en el referido anexo de
            datos.
          </li>
          <li>Todas las transacciones económicas se realizarán en euros.</li>
          <li>
            A los precios señalados se les sumarán los impuestos aplicables en
            cada caso.
          </li>
        </ol>
      </li>

      <li>
        Funcionamiento del programa
        <ol type="a">
          <li>
            INMATIC es un procesador de contabilización de facturas, tickets y/o
            documentos análogos, en adelante documento, cada vez que se procesa
            un documento el programa descuenta del saldo de paquete contratado y
            una vez llega al 90% de documentos contabilizados aparece un pop up
            en el programa a la vez que se envía un correo electrónico
            comunicando que el saldo contratado está a punto de ser agotado.
          </li>
          <li>
            El paquete de documentos contratados para contabilizar tiene la
            misma vigencia que el contrato, en ningún caso podrá ser acumulado
            el saldo no consumido fuera del año de vigencia del contrato.
          </li>
        </ol>
      </li>
      <li>Interrupción del Servicio</li>
      <ol type="a">
        <li>
          Coneptum se reserva el derecho a suspender temporalmente la prestación
          del Servicio para realizar labores de mantenimiento o mejora,
          notificándolo de forma anticipada al Cliente con al menos 24 horas de
          antelación.
        </li>
        <li>
          El cliente se compromete a facilitar una ventana horaria de
          mantenimiento trimestral y otra mensual para el parcheado general y el
          crítico respectivamente.
        </li>
        <li>
          No obstante, no se notificará de forma previa al Cliente, si dichas
          labores se realizan como respuesta a un problema grave o que afecte de
          forma drástica a la seguridad de la infraestructura, y, por tanto,
          Coneptum deba actuar de forma inmediata sin posibilidad de realizar la
          notificación previa.
        </li>
        <li>
          Del mismo modo, Coneptum se reserva el derecho a interrumpir
          temporalmente el Servicio sin previo aviso si observase:

          <ol type="1">
            <li>
              Un uso ilícito del Servicio o contrario a lo establecido en los
              Documentos del Servicio o a sus Políticas de uso.
            </li>
            <li>Un uso indebido o abusivo del Servicio.</li>
          </ol>
        </li>
      </ol>

      <li>
        Soporte técnico
        <p>
          Coneptum ofrece un servicio técnico base para cualquier cuestión del
          producto INMATIC que le pueda surgir al Cliente. La atención básica es
          en los días laborales de lunes a viernes dentro del horario comercial
          de 9 a 18 horas. Esta atención será mediante un correo electrónico y
          Coneptum valorará en cada una de las consultas si es necesario atender
          por otro medio que no sea el electrónico.
        </p>
        <p>Correo electrónico soporte@inmatic.ai</p>
      </li>

      <li>
        Responsabilidades
        <ol type="a">
          <li>
            Coneptum se compromete a realizar sus mejores esfuerzos, en el
            ejercicio de sus funciones, para asegurar el buen funcionamiento de
            los Servicios pero no será responsable de circunstancias o eventos
            que se encuentren fuera de su control, tales como el caso fortuito o
            fuerza mayor.
          </li>
          <li>
            Coneptum no se responsabiliza de fallos en el servicio como
            consecuencia de caídas del servicio del servidor del cliente
            derivados de un uso excesivo o erróneo de los recursos del mismo o
            de los recursos asignados al mismo, ataques externos o de terceras
            personas, fallos del software o similares.
          </li>
          <li>
            En ningún caso Coneptum será responsable de pérdidas de datos,
            interrupción de negocio o cualesquiera otros perjuicios producidos
            por el funcionamiento del Servicio que sea ajeno a la ejecución de
            Coneptum, o por no cumplir éste con las expectativas del Cliente.
          </li>
          <li>
            Coneptum no se responsabiliza de fallos en el servicio como
            consecuencia de que el Cliente no haya permitido la realización por
            parte de Coneptum del mantenimiento trimestral indicado.
          </li>
          <li>
            Ninguna de las Partes será responsable por el incumplimiento del
            presente Contrato si ello obedece a causas de Fuerza Mayor.
          </li>
          <li>
            Serán considerados como casos de fuerza mayor o caso fortuito, sin
            carácter limitativo, el retraso, fallo, suspensión o interrupción de
            los Servicios como consecuencia de las restricciones de energía,
            bloqueo de las telecomunicaciones o de la red Internet, acciones u
            omisiones de terceras personas, operadores de telecomunicaciones o
            compañías de servicios, suministro o transportes o cualesquiera
            otras causas o circunstancias independientes de la voluntad de
            Coneptum que impida la ejecución normal del presente contrato. 
          </li>
        </ol>
      </li>

      <li>
        Garantías
        <ol type="a">
          <li>
            Coneptum se compromete a prestar los servicios contratados con la
            máxima diligencia, utilizando personal con la debida experiencia y
            preparación, en cumplimiento de los procedimientos internos de
            Coneptum.
          </li>
          <li>
            Se consideran fuera del control de Coneptum, entre otros, los
            siguientes elementos o recursos:
            <ol type="1">
              <li>El sistema informático del usuario/s.</li>
              <li>El software contable del cliente.</li>
              <li>Software de navegación o de conexión y accesorios.</li>
              <li>
                Virus, troyanos, gusanos o cualquier otro programa informático
                hostil, nocivo o perjudicial.
              </li>
              <li>
                Red telefónica conmutada, RDSI, línea punto a punto, cable,
                satélite y cualquier otra infraestructura de transporte
                telecomunicaciones.
              </li>
            </ol>
          </li>
          <li>
            La garantía de disponibilidad de servicio no es de aplicación en
            caso de que el cliente haya incumplido alguna de las cláusulas de
            las presentes.
          </li>
        </ol>
      </li>

      <li>
        Ley aplicable y jurisdicción
        <p>
          El presente contrato se regirá e interpretará de acuerdo con las Leyes
          de España y se someterá a la jurisdicción de los Tribunales de
          Barcelona.
        </p>
      </li>
    </ol>


    <h4 class="text-center">ANEXO SERVICIOS CONTRATADOS</h4>
    <h4>Relación de servicios:</h4>
    <table>
      <tr>
        <th colspan="4">
          <h4>Servicio contratado</h4>
        </th>
      </tr>
      <tr>
        <td colspan="1" scope="col"></td>
        <td scope="col">Nº Docs./año procesados</td>
        <td scope="col">Precio</td>
        <td scope="col">Forma de pago</td>
      </tr>
      <tr>
        <td scope="row">Licencia anual</td>
        <td>{{ docs_num }}</td>
        <td>{{ price }} €*</td>
        <td>AÑO P/ADELANTADO</td>
      </tr>
    </table>
    <p class="subtitle">*Impuestos no incluidos</p>
    <br />


    <p>Forma de pago:</p>
    <p>El primer año se realizará mediante transferencia a la siguiente cuenta:</p>
    <p>Banc Sabadell – ES04 0081 0400 1100 0123 0926</p>
    <p>
      Cumplido el primer año de contrato, la Compañía se reserva el derecho de
      regular el importe mensual en el marco del contrato anual, así como la
      modalidad de pago, notificándoselo al Cliente a través de un correo
      electrónico, con efecto a partir de los 30 (treinta) días desde que se realizó
      la comunicación.
    </p>
    <p>
      El Cliente tendrá un plazo de 7 días de prueba contados a partir de la
      activación de la Plataforma donde podrá procesar hasta un máximo de 100
      documentos. Cumplido dicho plazo o habiendo alcanzado los 100
      documentos procesados, en caso de querer seguir con la contratación, se le
      enviará una factura que deberá abonar mediante transferencia bancaria a la
      cuenta antes indicada.
    </p>
    <p>
      En caso de no estar conforme con el programa, deberá notificar la
      desactivación del mismo mediante notificación por correo electrónico a
      soporte@inmatic.ai.
    </p>




    <div class="d-flex justify-space-around">
      <div>Coneptum S.L</div>
      <div>{{ business_name }}</div>
    </div>
    <div class="d-flex justify-space-around pt-10 pb-10">
      <div>Antonio Bagur Cantallops</div>
      <div>{{ name }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PolicyServices",
  props: {
    postal_address: String,
    province: String,
    bussnies_id: String,
    business_name: String,
    name: String,
    docs_num: String,
    price: String,
    date: String,
  },
};
</script>

<style scoped>
.subtitle {
  font-size: small;
}

table {
  border: 1px solid black;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
  text-align: center;
}

table tr {
  border: 1px solid black;
  padding: .35em;
}

table th,
table td {
  padding: .625em;
  border: 1px solid black;
}

table th {
  font-size: .85em;
  letter-spacing: .1em;
  text-transform: uppercase;
}
</style>
